<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre2">
<h1 class="calibre15" id="pgepubid00000"><span class="calibre16">NINETIETH DAY</span><br class="calibre5"/> Monday, 25 March 1946</h1>
</div>
<h2 class="nobreak" id="pgepubid00001"><span>Morning Session</span></h2>
<p class="pindent">MARSHAL (Colonel Charles W. Mays): May it please the Court:
the Defendants Streicher and Ribbentrop are absent from this
session.</p>
<p class="pindent">THE PRESIDENT (Lord Justice Sir Geoffrey Lawrence):
Dr. Seidl.</p>
<p class="pindent">DR. ALFRED SEIDL (Counsel for Defendant Hess): Mr. President,
Your Honors, on Friday last I stated that I would not read anything
from the first volume of the document book; that does not mean,
however, that I should not like to refer to one or another document
in my final speech. The question now arises whether, under these
circumstances, documents to which I may refer, but which I will
not read now should be submitted as evidence to the Court, or
whether it is sufficient if these documents are copied down in the
book. I would be grateful if the Court would help me regarding
this question.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE (Deputy Chief Prosecutor for the
United Kingdom): My Lord, I have a suggestion to make: That the
Tribunal take these documents <span class="it1">de bene esse</span> at the moment, and that
when Dr. Seidl comes to make his final speech, then any point as to
admissibility can be discussed. With regard to the third book, for
example, that consists of a number of opinions of various politicians
and economists in various countries. The Prosecution will, in due
course, submit that these have no evidential value and in fact relate
to a matter too remote to be relevant. But I should have thought the
convenient course would have been to discuss that when we find
what ultimate use Dr. Seidl makes of the documents, at the moment
letting them go in, as I suggest, <span class="it1">de bene esse</span>.</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, the Tribunal think that you should
offer the documents in evidence now, and that they should be numbered
consecutively. Probably the best way would be with the letter
“H” in front of them—H Number 1 and so on—and that then, as Sir
David says, as they are being offered all together, objection, if
necessary, can be taken to them at a later stage—objection on the
ground of admissibility or relevance.
<span id="Page_2" title="2"></span></p>
<p class="pindent"> DR. SEIDL: Very well. I turn once more to Volume I of the
document book. The first document is a speech made by the Defendant
Rudolf Hess on 8 July 1934. This document will bear the
Number H-1, Page 23 of the document book. The second document
can be found on Page 27 of the document book...</p>
<p class="pindent">THE PRESIDENT: One moment, Dr. Seidl. To what issue has
this speech got relevance?</p>
<p class="pindent">DR. SEIDL: The speech of 8 July 1934?</p>
<p class="pindent">THE PRESIDENT: Yes. Well, it is the one on Page 23. It is
8 July 1934.</p>
<p class="pindent">DR. SEIDL: Yes, Mr. President, this speech deals with the question
of war and peace. Since the Defendant Hess is accused of
having participated in the psychological preparation of aggressive
war, and thus also of being a participant in the conspiracy, it seems
to me that the attitude of the Defendant Hess toward the question
of war is of considerable importance as regards evidence.</p>
<p class="pindent">THE PRESIDENT: Very well. We will allow you to read it.</p>
<p class="pindent">DR. SEIDL: Mr. President, I do not intend to read the speech
now. I only want to bring up the speech as an exhibit so as to be
able to refer to it in my final speech, if necessary.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<p class="pindent">DR. SEIDL: I shall read nothing at all from the first document
book. I shall only mention certain documents as exhibits.</p>
<p class="pindent">I turn to Page 28 of the document book. This is another speech
by the Defendant Hess, delivered on 27 November 1934. The number
of this exhibit will be H-2.</p>
<p class="pindent">THE PRESIDENT: The speech of 8 December 1934 begins on
Page 27.</p>
<p class="pindent">DR. SEIDL: Page 27, that is right. It was marked here incorrectly.
As the third exhibit I submit a speech—that is to say, an
excerpt from a speech—of 17 November 1935, Page 31 of the document
book, Exhibit Number H-3.</p>
<p class="pindent">I turn to Page 32 of the document book, an excerpt from a
speech of 11 October 1936, Exhibit Number H-4.</p>
<p class="pindent">Then comes a speech of 14 March 1936, Page 33 of the document
book, Exhibit Number H-5.</p>
<p class="pindent">The next exhibit is on Page 35 of the document book, a speech
of 21 March 1936, Exhibit Number H-6.</p>
<p class="pindent">Exhibit Number H-7 is a speech on Page 36 of the document
book.</p>
<p class="pindent">Exhibit Number H-8 is a speech of 6 June 1936, on Page 40 of
the document book.
<span id="Page_3" title="3"></span></p>
<p class="pindent">Then, I turn to Page 43 of the document book, a speech at the
Reichsparteitag in Nuremberg 1936, Exhibit Number H-9.</p>
<p class="pindent">There follow excerpts of a speech on Page 59 of the document
book, Exhibit Number H-10.</p>
<p class="pindent">A speech of 14 May 1938 at Stockholm is found on Page 70 of
the document book, Exhibit Number H-11.</p>
<p class="pindent">The next exhibit is on Page 78 of the document book, Exhibit
Number H-12.</p>
<p class="pindent">So much for the first volume of the document book.</p>
<p class="pindent">I pass on to the second volume, to the affidavit which I submitted
last Friday. It can be found on Page 164 of the document book. It
is an affidavit made by the former Secretary, Hildegard Fath, and
it will bear the Exhibit Number H-13.</p>
<p class="pindent">The next exhibit is on Page 86 of the document book, Volume 2,
a decree of 3 June 1936, Exhibit Number H-14.</p>
<p class="pindent">And now I come to the point where I shall read certain excerpts
from the minutes of the meeting between the Defendant Hess and
Lord Simon, which took place on 10 June 1941. These minutes begin
on Page 93 of the document book. The minutes will have the Exhibit
Number H-15.</p>
<p class="pindent">Your Honors, the Defendant Hess, on 10 May 1941, flew to England.
Nobody except his then adjutant, Hitsch, knew of this flight.
The Führer himself was informed about the flight and the intentions
connected therewith in a letter which was delivered to the
Führer after Hess had already landed in England. After his arrival
in England Hess was frequently questioned by officials of the Foreign
Office, and, as already mentioned, a meeting took place between him
and Lord Simon on 10 June 1941. This meeting lasted two hours
and a half. In the course of this meeting the Defendant Hess told
Lord Simon the reasons for his extraordinary undertaking and he
then submitted four proposals, or four points, which he claimed
would give the intentions of Adolf Hitler, and which he considered
to be the basis for an understanding and a conclusion of peace.</p>
<p class="pindent">For the conference Lord Simon assumed a pseudonym; in the
minutes which were given to the Defendant Hess shortly after the
meeting, he is referred to as Dr. Guthrie.</p>
<p class="pindent">As far as I know, this measure was probably taken to prevent
the stenographers or the translators from knowing at once
what it was all about. In the minutes mention is also made of
a Dr. Mackenzie, an official of the Foreign Office, and of Mr. Kirkpatrick,
who had previously already spoken with the Defendant Hess.</p>
<p class="pindent">After a few introductory remarks by Lord Simon, the Defendant
Hess began to explain the reasons which led him to take his singular
step, and I quote liberally from Page 93 of the document book,
<span id="Page_4" title="4"></span>
about the middle of the page. I must add that in the minutes, the
Defendant Hess is referred to by the name “J.” The Defendant Hess,
after the introductory remarks, said the following...</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, there seems to be a typographical
error, probably in the date. The date is given as the 9th of August.
You said the 10th of June, did you not?</p>
<p class="pindent">DR. SEIDL: 10 June, yes.</p>
<p class="pindent">THE PRESIDENT: Is this a mistake at the top of Page 93—9. 8. 41?</p>
<p class="pindent">DR. SEIDL: On the cover of the document there is the following
remark: “Minutes of the conversation which took place on 9 June
1941 somewhere in England.” On the inside of the document, there
is also the entry 9. 6. 41; so there must obviously be a typographical
error here.</p>
<p class="pindent">THE PRESIDENT: Yes, it must have been. They put “8” instead
of “6.”</p>
<p class="pindent">DR. SEIDL: Yes.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<div class="blockquote">
<p class="calibre3">DR. SEIDL: “I know that probably nobody has correctly
understood my coming; but in view of the extraordinary step
that I have taken, that can by no means be expected. Therefore
I would like to begin by explaining how I came to
do this.”</p>
</div>
<p class="pindent">I continue on Page 94:</p>
<div class="blockquote">
<p class="calibre3">“The idea came to me in June of last year, during the time
of the French campaign, while visiting the Führer....”</p>
</div>
<p class="pindent">I believe I may omit the following incidental remarks and continue
quoting further:</p>
<div class="blockquote">
<p class="calibre3">“I must admit that I came to the Führer convinced, as we all
were, that sooner or later in the end we would surely conquer
England, and I expressed the opinion to the Führer that we
must naturally demand from England the restitution of
property—such as the equivalent of our merchant fleet,
<span class="it1">et cetera</span>—which had been taken from us by the Versailles
Treaty.”</p>
</div>
<p class="pindent">I turn to Page 95:</p>
<div class="blockquote">
<p class="calibre3">“The Führer then immediately contradicted me. He was of
the opinion that the war could possibly be an occasion for
coming to an agreement with England for which he had
striven ever since he had been politically active. To this I can
testify, that ever since I have known the Führer, since 1921,
<span id="Page_5" title="5"></span>
the Führer has always said that an agreement between Germany
and England had to be achieved. He said he would bring
this about as soon as he was in power. He told me at that
time in France that one should not impose any severe conditions,
even if victorious, on a country with which one desired
to come to an agreement. Then I conceived the idea that if
this were known in England, it might be possible that England
also might be ready for an agreement.”</p>
</div>
<p class="pindent">I turn now to Page 96 of the document book.</p>
<div class="blockquote">
<p class="calibre3">“Then, at the conclusion of the French campaign came the
Führer’s offer to England. The offer, as is known, was refused.
This made me all the more firm in my belief that under these
circumstances I had to execute my plan. During the subsequent
period came the air war between Germany and England,
which, on the whole, meant heavier losses and damages
for England than for Germany. Consequently, I had the
impression that England could not give in at all without
suffering considerable loss of prestige. That is why I said to
myself, ‘Now I must realize my plan all the more, for if I
were over in England, England could be enabled to take up
negotiations with Germany without loss of prestige.’ ”</p>
</div>
<p class="pindent">I turn now to Page 97 of the document book. After a short incidental
remark by Dr. Mackenzie, Hess continued:</p>
<div class="blockquote">
<p class="calibre3">“I was of the opinion that, apart from the question of the
terms for an agreement, there would be still in England a
certain general distrust to overcome. I must confess that I
faced a very grave decision, the gravest in my life, of course,
and I believe I was aided by continuously keeping before my
inner vision the picture of an endless row of children’s coffins
with the mothers weeping behind them on the German side
as well as on the English side...”</p>
</div>
<p class="pindent">THE PRESIDENT: Dr. Seidl, have you got the original document
there before you?</p>
<p class="pindent">DR. SEIDL: Yes.</p>
<p class="pindent">THE PRESIDENT: Might it be handed up?</p>
<p class="pindent">DR. SEIDL: Yes.</p>
<p class="pindent">[<span class="it1">The document was handed to the President.</span>]</p>
<p class="pindent">THE PRESIDENT: Yes, go on.</p>
<div class="blockquote">
<p class="calibre3">DR. SEIDL: “...and vice versa, the coffins of mothers with
the children behind them.</p>
<p class="calibre3">“I want to mention certain points which, I believe, have a certain
importance from the psychological point of view. I must
go back a bit. After Germany’s defeat in the World War, the
<span id="Page_6" title="6"></span>
Versailles Treaty was imposed on her, and no serious historian
is today still of the opinion that Germany was responsible for
the World War. Lloyd George has said that the nations
stumbled into the war. I recently read an English historian,
Farrar, who wrote about Edward VII and his policy at that
time. This historian, Farrar, lays the main guilt for the war,
on the policies of Edward VII. After her collapse Germany
had this treaty imposed upon her, which was not only a
frightful calamity for Germany but also for the whole world.
All attempts of politicians, of statesmen in Germany, before
the Führer came to power—that is to say, when Germany was
a pure democracy—to obtain any sort of relief failed.”</p>
</div>
<p class="pindent">I forego the reading of the following part of the minutes literally.
A conversation followed on various points. Among other things the
subject of the conversation then was the air strength of Germany at
that time and the preparations with regard to the building of
U-boats. I do not believe that these questions are relevant in the
present connection, and so I shall turn at once to that part of the
minutes where mention is made of the proposals which Hess made
to Lord Simon. This is on Page 152 of the document book. From
the minutes we can see that Hess had previously written down
the proposals which he wanted to submit. He gave these notes to
Dr. Mackenzie and Mr. Kirkpatrick, who then read and translated
them, and now I quote on Page 152, at the bottom of the page,
literally:</p>
<p class="pindent">“Basis for an understanding.” And here I have to ask the Tribunal
to turn from Page 152 of the document book to Page 159 of
the document book because the first point in the proposal obviously
has been presented in the wrong fashion. On Page 159, about the
middle of the page, there is a statement by Dr. Mackenzie which
expresses the first point correctly, and I quote:</p>
<div class="blockquote">
<p class="calibre3">“In order to prevent future wars between the Axis and England,
the limits of the spheres of interest should be defined.
The sphere of interest of the Axis is Europe, and England’s
sphere of interest is the Empire.”</p>
</div>
<p class="pindent">I ask now that you turn back, namely to Page 153 of the document
book. Here we find on the last line the second point of the
proposals which Hess made. Dr. Mackenzie is reading:</p>
<div class="blockquote">
<p class="calibre3">“2. Return of German Colonies.”</p>
</div>
<p class="pindent">I turn to Page 154 of the document book and begin to quote at
the top of the page—it is possible that the figure “2” is inadvertently
repeated here in the document book. It should be:</p>
<div class="blockquote">
<p class="calibre3">“3. Indemnification of German citizens who before or during
the war had their residence within the British Empire, and
who suffered damage to life and property through measures
<span id="Page_7" title="7"></span>
of a Government of the Empire or as a result of pillage, riot,
<span class="it1">et cetera</span>; indemnification of British subjects by Germany on
the same basis.</p>
<p class="calibre3">“4. Armistice and peace to be concluded with Italy at the
same time.”</p>
</div>
<p class="pindent">Then there is a personal remark by Hess as follows:</p>
<div class="blockquote">
<p class="calibre3">“The Führer in our conversation repeatedly presented these
points to me in general as the basis for an understanding with
England.”</p>
</div>
<p class="pindent">I shall not read any further excerpts from these minutes.</p>
<p class="pindent">I forego the reading of the other passages marked in red. The
conference was terminated by a statement made by Lord Simon to
the effect that he would bring the proposals made by Hess to the
knowledge of the British Government. That was Exhibit Number H-15.</p>
<p class="pindent">Your Honors, the Defendant Rudolf Hess is accused in the Indictment
of helping the Nazi conspirators to seize power and of furthering
the military, economic, and psychological preparations for
the war as mentioned under Count One of the Indictment; of participating
in the political planning and preparation of aggressive wars
and of war in violation of international treaties, agreements and
promises, as mentioned in Counts One and Two, and of participating
in the preparation and planning of foreign political plans of the
Nazi conspirators as listed under Count One.</p>
<p class="pindent">That accusation is the nucleus of the Indictment against Rudolf
Hess. It is therefore my duty to discuss also briefly in evidence the
circumstances which in 1939 led to the outbreak of war. In that
respect I have the following to say:</p>
<p class="pindent">On 23 August 1939, at Moscow a non-aggression pact was concluded
between Germany and the Soviet Union, which has already
been submitted by the Prosecution as Exhibit GB-145 (Document
TC-25). On the same day, that is to say but 1 week before the
outbreak of the war and 3 days before the planned attack on Poland,
these two nations made another secret agreement. This secret agreement
essentially contained the definition of the spheres of interest
of both nations within the European territory lying between Germany
and the Soviet Union.</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, you are not forgetting, are you, the
Tribunal’s ruling that this is not the opportunity for making a
speech, but simply the occasion for introducing documents and
calling witnesses. You will have the opportunity of making your
speech at a later stage.</p>
<p class="pindent">DR. SEIDL: Yes, indeed. I do not intend to make a speech, but
I intend to say a few introductory words on a document which I
shall submit to the Tribunal.
<span id="Page_8" title="8"></span></p>
<p class="pindent">Germany, in the secret documents, declared herself disinterested
in Lithuania, Latvia, Estonia, and Finland.</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, we have not yet seen the document.
If you are going to put in the document, put in the document.</p>
<p class="pindent">DR. SEIDL: Yes, indeed. I can submit the document at once. It
is an affidavit of the former ambassador, Dr. Friedrich Gaus. In the
year 1939 he was the Chief of the Legal Department of the Foreign
Office. He was present at the negotiations as the assistant of the
then German plenipotentiary in Moscow, and it was he who drafted
the non-aggression pact which has already been submitted as an
exhibit, as well as the secret agreement, the contents of which I
want to submit now to the Tribunal as facts which are important
as evidence.</p>
<p class="pindent">THE PRESIDENT: Well, will you hand in the document?</p>
<p class="pindent">DR. SEIDL: Surely. However, I intend to read parts of this document
later.</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, the Tribunal does not quite understand
what this document is, because it is not included in your
document book and it does not appear that you made any application
for it or made any reference to it, and it is in German; it is not
translated.</p>
<p class="pindent">DR. SEIDL: Mr. President, when I prepared the document book
for the Defendant Hess, I did not as yet have this affidavit in my
possession. It dates from 15 March 1946. At that time, when the
relevancy of the applications for Defendant Hess were discussed, I
had as yet no definite knowledge of the context which would have
enabled me to make a proper application. The excerpts which I
intend to read from this document are short, and it will be possible
to have them translated immediately by the interpreters present
here in the courtroom.</p>
<p class="pindent">THE PRESIDENT: Have you a copy for the Prosecution?</p>
<p class="pindent">DR. SEIDL: Surely, a German copy.</p>
<p class="pindent">THE PRESIDENT: I am afraid that would not be any use to me.
I do not know whether it is to all the members of the Prosecution.
Have the Prosecuting Counsel any objection to passages being read
from this document?</p>
<p class="pindent">GENERAL R. A. RUDENKO (Chief Prosecutor for the U.S.S.R.):
Mr. President, I did not know about the existence of this document,
and I therefore strenuously object to having it read into the record.
I would wish that the procedure established by the Tribunal be
observed by the Defense. The Prosecution, in the past, when
presenting its evidence invariably presented copies of these documents
to the Defense Counsel. Counsel for Hess is now presenting
<span id="Page_9" title="9"></span>
a completely unknown document, and the Prosecution, with every
reason, would like to familiarize itself with this document beforehand.
I do not know what secrets or what secret agreements Counsel
for the Defense is talking about and on what facts he is basing his
statements. I would therefore, to say the least, define them as
unfounded. I request that this document should not be read into the
record.</p>
<p class="pindent">DR. SEIDL: The Prosecutor for the Soviet Union states that he
has no knowledge of the existence of this secret document which
shall be established by this affidavit. Under these circumstances I
am compelled to move that Foreign Commissar Molotov of the
Soviet Union be called as a witness, so that it can be established,
firstly whether this agreement was actually concluded, secondly,
what the contents of this agreement are, and thirdly...</p>
<p class="pindent">THE PRESIDENT: Dr. Seidl, the first thing for you to do is to
have a translation of this document made, and until you have a
translation of this document made, the Tribunal is not prepared to
hear you upon it. We do not know what the document contains.</p>
<p class="pindent">DR. SEIDL: As to what the document contains, I already wanted
to explain that before. In the document there is...</p>
<p class="pindent">THE PRESIDENT: No, the Tribunal is not prepared to hear from
you what the document contains. We want to see the document
itself and see it in English and also in Russian. I do not mean, of
course, you have to do it yourself, Dr. Seidl. If you would furnish
this copy to the Prosecution they will have it translated into the
various languages and then, after that has been done, we can
reconsider the matter.</p>
<p class="pindent">DR. SEIDL: Very well. I turn then to another document, the
reading of which can certainly raise no objections, because it is a
document which has already been submitted by the Prosecution. It
is the address made by the Führer to the Commanders-in-Chief of
the Armed Forces on 22 August 1939. It was submitted by the
Prosecution of the Soviet Union as 798-PS and as Exhibit Number
US-29. I quote from Page 6 of the German photostat: “Thereupon
Hitler declared...”</p>
<p class="pindent">THE PRESIDENT: Have you got it in your document book or
not, I mean just for convenience?</p>
<p class="pindent">DR. SEIDL: The document was already submitted by the Prosecution
in full.</p>
<p class="pindent">THE PRESIDENT: You mean it is not here. I have not got the
document before me. It is not in your document book?</p>
<p class="pindent">DR. SEIDL: No, it is not in the document book because the Court
has already ruled that each defendant’s counsel has the right to
<span id="Page_10" title="10"></span>
refer to any document which has already been submitted by the
Prosecution. I quote:</p>
<div class="blockquote">
<p class="calibre3">“...I have gradually brought about a change in our attitude
towards Russia. In connection with the trade agreement, we
got into a political conversation. Proposal of a non-aggression
pact. Then came a general proposal from Russia. Four
days ago I took a special step which had as a result that
Russia answered yesterday she was ready for settlement.
Personal contact with Stalin has been established. Von
Ribbentrop will conclude the treaty the day after tomorrow.
Now Poland is in the position in which I wanted her to be.”</p>
</div>
<p class="pindent">End of the quotation.</p>
<p class="pindent">Mr. President, Gentlemen: I had now the intention to call the
witness Bohle who has already been approved by the Tribunal. The
Defendant Hess, however, has asked me to forego the personal
appearance of that witness and read an affidavit concerning the
facts of evidence in reference to which the witness was to be heard.</p>
<p class="pindent">I have prepared such an affidavit, and undoubtedly it would
accelerate the proceedings if the Tribunal would permit the reading
of this affidavit. If however, the Tribunal should have the opinion
that...</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: I have not had the opportunity
of seeing the affidavit. As previously advised, if the witness covers
the ground for which he was asked, I should want him for cross-examination.</p>
<p class="pindent">THE PRESIDENT: Where is the witness?</p>
<p class="pindent">DR. SEIDL: He is here. With the permission of the Tribunal I
would like to call the witness Bohle now.</p>
<p class="pindent">THE PRESIDENT: Do you mean to call him or to read his
affidavit?</p>
<p class="pindent">DR. SEIDL: Yes, indeed; since Sir David Maxwell-Fyfe apparently
protests against the reading of the affidavit, I would like to
call the witness.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: I have not seen the affidavit, of
course, My Lord, so at the moment, as I say, if the affidavit covers
the ground that the witness should speak upon, then I shall want
to cross-examine him.</p>
<p class="pindent">THE PRESIDENT: Unless the Prosecution are agreeable that the
affidavit should be put in, the witness must be called, but if the
Prosecution are agreeable to the affidavit being read and then the
witness presented for cross-examination, the Tribunal is quite willing
that it should be done.
<span id="Page_11" title="11"></span></p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: I do not mind that in the least,
My Lord. Of course, I am in slight difficulty not knowing what is
in the affidavit.</p>
<p class="pindent">THE PRESIDENT: Perhaps the best course would be for the
Tribunal to have a 10-minute adjournment now, and you could perhaps
just see what is in the affidavit.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: It is a pleasure, My Lord.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00002">[<span class="it1">A recess was taken.</span>]</h3>
<p class="pindent">THE PRESIDENT: The Tribunal did not wish to hurry counsel,
but we thought we had better get on with other witnesses, and this
document can be translated and considered and possibly dealt with
after the main adjournment.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: If Your Lordship pleases, I have
not had the chance of reading the translation. A preliminary view
of the affidavit convinced my staff that it was not of very great
importance, and I was going to consider whether the quickest way
might be to let the affidavit be read, if the Tribunal would then
permit me to read three documents which I was going to put in
cross-examination to the witness. That might be more convenient
than to take the course which Your Lordship suggests, of waiting
until we have seen the full affidavit and then consider what would
be the best way to deal with it.</p>
<p class="pindent">THE PRESIDENT: Well, you have perhaps seen part of the document,
and you can perhaps judge better which would be the more
convenient course. Whichever you think more convenient.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: Well, I am quite content if
Dr. Seidl reads it, but it would have to be on the terms that the
documents which I was going to put in cross-examination to the
witness are read.</p>
<p class="pindent">THE PRESIDENT: The Tribunal thinks he had better be called.</p>
<p class="pindent">SIR DAVID MAXWELL-FYFE: If Your Lordship pleases.</p>
<p class="pindent">THE PRESIDENT: Yes; Dr. Seidl?</p>
<p class="pindent">DR. SEIDL: If I understood the High Tribunal correctly, they
do not wish to have the affidavit read but to have the witness interrogated
before the Court.</p>
<p class="pindent">THE PRESIDENT: Well, as soon as the affidavit has been translated,
and the Prosecution have had an opportunity of considering
it, they can let us know whether they think it will be better to
treat the affidavit as the examination of the witness, and he must
<span id="Page_12" title="12"></span>
then be produced here for the purpose of cross-examination unless
you prefer to examine him orally yourself.</p>
<p class="pindent">DR. SEIDL: I believe that under these circumstances it would be
best to call the witness immediately to the witness stand.</p>
<p class="pindent">THE PRESIDENT: Very well.</p>
<p class="pindent">[<span class="it1">The witness Bohle took the stand.</span>]</p>
<p class="pindent">THE PRESIDENT: Will you tell me your name?</p>
<p class="pindent">ERNST WILHELM BOHLE (Witness): Ernst Wilhelm Bohle.</p>
<p class="pindent">THE PRESIDENT: Will you repeat this oath after me: I swear
by God—the Almighty and Omniscient—that I will speak the pure
truth—and will withhold and add nothing.</p>
<p class="pindent">[<span class="it1">The witness repeated the oath in German.</span>]</p>
<p class="pindent">DR. SEIDL: Witness, you were ultimately the leader of the Auslands-Organisation
of the NSDAP? Is that correct?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">DR. SEIDL: You were also State Secretary of the Foreign Office?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">DR. SEIDL: Mr. President, Mr. Dodd of the American Prosecution
just made the suggestion that, in order to save time, it might be
possible to follow the same procedure as in the case of witness
Blaha, that is, first of all, to read the affidavit in the presence of
the witness and then afterwards hear him in cross-examination.</p>
<p class="pindent">THE PRESIDENT: Yes, certainly.</p>
<p class="pindent">DR. SEIDL [<span class="it1">Turning to the witness.</span>]: You made an affidavit
which I shall now read to you. Concerning the matter:</p>
<div class="blockquote">
<p class="calibre3">“1. The Auslands-Organisation of the NSDAP was founded
on 1 May 1931 at Hamburg upon suggestion of some Germans
abroad. Gregor Strasser, Reich Organization Chief at the time,
appointed as its leader the NSDAP Member of the Reichstag,
Dr. Hans Nieland.</p>
<p class="calibre3">“I myself became a volunteer assistant of the Auslands-Organisation
in December 1931 and was taken into the Party on
1 March 1932. On 8 May 1933 Dr. Nieland resigned as leader
of the Auslands-Organisation, having become in the meantime
a member of the Hamburg Government and also, as a German
who had always stayed at home, being less interested in questions
concerning Germans abroad. On account of my experience—and
my connections abroad—I was born in England and
raised in South Africa—I was charged with the leadership of
the Auslands-Organisation.</p>
<p class="calibre3">“2. The purpose of the Auslands-Organisation was, upon the
assumption of power, to hold together in an organized way
<span id="Page_13" title="13"></span>
the approximately 3,300 Party members living outside the
boundaries of Germany at the time of the seizure of power.
Further, through it Germans abroad, who could have only a
vague idea of the political happenings at home, were to be
taught the philosophy and the political program of the new
state.</p>
<p class="calibre3">“3. Only German nationals could become members of the Party.
The acceptance of foreigners or former Germans who had
acquired citizenship in another state was strictly prohibited.</p>
<p class="calibre3">“4. The guiding principle of the Auslands-Organisation of the
Party concerning its attitude to foreign countries was found
on the Ausland pass of every German national who was a
member of the Party, in the following passage: ‘Observe the
laws of the country whose guest you are. Let the citizens of
the country in which you stay take care of their internal
politics; do not interfere in these matters, not even by way of
conversation.’</p>
<p class="calibre3">“This principle was basic for the work and the attitude of the
Auslands-Organisation with respect to foreign countries from
the day of its founding up to its end. I myself referred to this
in many public speeches, and in so doing coined, among others,
the phrase: ‘The National Socialist honors foreign folkdom
because he loves his own.’</p>
<p class="calibre3">“My speeches in Porchester Hall in London on 2 October 1937
and in Budapest at the end of January 1938 give a comprehensive
picture of the attitude of the Auslands-Organisation of
the NSDAP toward foreign countries.</p>
<p class="calibre3">“Winston Churchill in the late summer of 1937 repeatedly
attacked the activity of the Auslands-Organisation in newspaper
articles, and in his well-known article, ‘Friendship with
Germany,’ in the London <span class="it1">Evening Standard</span> of 17 September
1937, designated it as an encumbrance on German-English
relations. In the same article he said that he was ready to
converse with me in the most cordial manner about this question.
The German Embassy in London informed the Foreign
Office at that time that a question by Churchill in the House
of Commons regarding the activity of the Auslands-Organisation
would be extremely undesirable. As a result a meeting
between Churchill and myself was advocated as urgent. This
took place on the day of my speech to the Reich Germans in
London, in Winston Churchill’s London home, and lasted more
than an hour. I had ample opportunity in this thoroughly
cordial conversation to describe the activity of the Auslands-Organisation
and to dispel his misgivings. At the end he accompanied
me to my car and let himself be photographed with
<span id="Page_14" title="14"></span>
me, in order, as he said, to show the world that we were
parting as friends. There was no inquiry in the House of
Commons. From that day Churchill never uttered a word of
objection again about the activity of the Auslands-Organisation.
My speech of the same date, which was published
shortly afterwards in English in pamphlet form by an English
concern, was very favorably received. <span class="it1">The Times</span> published
from it a lengthy excerpt under the heading ‘Herr Bohle’s Plea
for an Understanding.’ After this conversation Churchill wrote
me a letter in which he voiced his satisfaction with the result
of our conversation.</p>
<p class="calibre3">“6. In the trial of the murderer of the Landesgruppenleiter of
the Auslands-Organisation in Switzerland, Wilhelm Gustloff,
which was held in a Swiss court at Chur in 1936, the legality
of the activity of the Auslands-Organisation was the subject
of investigation by the court. The Defendant, David Frankfurter,
was sentenced to 18 years imprisonment. From what
I remember, I can say that the Swiss authorities, who were in
no way friendly to Nazis, had to testify that Gustloff and the
Landesgruppen of the Auslands-Organisation had never in
any way given reason for complaint with regard to their
activity. The testimony of Federal Councillor Baumann, who,
to my knowledge, was then Minister of the Interior and of the
Police in Switzerland, was at that time decisive.</p>
<p class="calibre3">“7. I should further like to point out in this connection that
also after the outbreak of the war the Landesgruppen of the
Auslands-Organisation in neutral countries continued to function
until the end of the war. That is especially true of
Switzerland, Sweden, and Portugal.</p>
<p class="calibre3">“From 1943 on, at the latest, the Reich would hardly have been
able to take any steps against suppression, if the Auslands-Organisation
had come into conflict with the internal laws of
these countries; and suppression would have been the inevitable
result.</p>
<p class="calibre3">“8. Aside from the indisputable legality of the Auslands-Organisation,
as its leader I have repeatedly expressed the
idea that the Auslandsdeutschen (Germans abroad) would
certainly be the last people who would let themselves be
misused as warmongers or as conspirators against the peace.
From bitter experience they knew that with the outbreak of
the war they would face at once internment, persecution, confiscation
of property, and destruction of their economic existence.</p>
<p class="calibre3">“9. As a result of the knowledge of the situation abroad, no
one knew better than the Auslandsdeutschen that any activity
<span id="Page_15" title="15"></span>
in the sense of a Fifth Column would be just as foolish as
detrimental to the interests of the Reich. To my knowledge,
moreover, the expression ‘Fifth Column’ can be traced back
to the Spanish Civil War. It is in any case a foreign invention.
When Franco attacked Madrid with four columns of troops, it
was asserted that a Fifth Column consisting of nationalist
elements was doing its seditious work underground within the
besieged city.</p>
<p class="calibre3">“10. There is no basis whatsoever for applying the term ‘Fifth
Column’ to the Auslands-Organisation of the NSDAP. If this
assertion were true, it would mean that members of the Auslands-Organisation
working together with local oppositional
elements in one or more foreign countries had been delegated,
or had by themselves tried, to undermine this state from
within. Any such assertion would be pure invention.</p>
<p class="calibre3">“11. Neither from the former Deputy of the Führer, Rudolf
Hess, nor from me, as the leader of the Auslands-Organisation,
has this organization or members of this organization
in any way received orders the execution of which might
be considered as Fifth Column activity. Even Hitler himself
never gave me any directive in that respect. In summary,
I can say that the Auslands-Organisation at no time, as
long as I was its leader, displayed any activity in the sense
of a Fifth Column. Never did the Deputy of the Führer give
orders or directives to the Auslands-Organisation which
might have led to such activity. On the contrary, Rudolf
Hess most urgently desired that members of the Auslands-Organisation
should under no circumstances take part in the
internal affairs of the country in which they were living
as guests.</p>
<p class="calibre3">“12. Of course, it is known that just as citizens of the
then enemy countries, so also Germans were employed in
the espionage and intelligence services abroad. This activity
had however nothing at all to do with membership in the
Auslands-Organisation. In order not to imperil the existence
of the Auslands-Organisation groups, which worked legally
and entirely in the open, I constantly demanded that members
of the Auslands-Organisation would not be used for such
purposes or that I should previously be given the opportunity
to relieve them of their functions within the Auslands-Organisation.”</p>
</div>
<p class="pindent">And that is the end of the statement of the witness Bohle. For
the moment I have no questions to ask the witness, Your Honor.</p>
<p class="pindent">THE PRESIDENT: Do any of the defendants’ counsel wish to
ask the witness any questions?
<span id="Page_16" title="16"></span></p>
<p class="pindent">DR. FRITZ SAUTER (Counsel for Defendant Von Schirach): I
would like to put several questions to this witness, Your Honor.</p>
<p class="pindent">Witness, I represent the Defendant Von Schirach, the former
leader of the German Youth. Therefore the following would interest
me: Did the Hitler Youth (HJ) also exist in foreign countries or
only in Germany?</p>
<p class="pindent">BOHLE: The Hitler Youth existed among German nationals in
foreign countries also.</p>
<p class="pindent">DR. SAUTER: Please tell me whether this HJ, the Hitler
Youth abroad, was subject to the political directives of the competent
Landesleiter of the Auslands-Organisation, or is that
not right?</p>
<p class="pindent">BOHLE: Yes, the Hitler Youth abroad was politically under
the control of the Hoheitsträger of the Party.</p>
<p class="pindent">DR. SAUTER: Once in the course of the proceedings the assertion
was made that members of the Hitler Youth were trained
for service as agents and for espionage work abroad and also
were used for these purposes. Specific facts, that is, specific
instances, were certainly not mentioned, but only a general assertion
was made, and it was also asserted that Hitler Youth abroad
were even used as paratroopers, that is, that they had been trained
at home as paratroopers in order to be used abroad in this capacity.</p>
<p class="pindent">That is the assertion which I submit to you, and I now ask
to have your opinion on this, whether, on the basis of your knowledge
as the competent leader of the Auslands-Organisation,
something like that did occur or whether anything like that was
at all possible?</p>
<p class="pindent">BOHLE: I would like to say the following in reply: I consider
it entirely out of the question that members of the Hitler Youth
abroad were misused in this way. I can assert that so much the
more since I know I would have heard anything to the contrary
from the leaders of the Party in the various foreign countries.
I know also nothing at all about the training of the Hitler Youth
as paratroopers or anything similar. I consider these assertions
as absolutely pure invention.</p>
<p class="pindent">DR. SAUTER: Then I may assume, as the result of your testimony,
that things of that sort on the basis of the entire organization
would certainly have come to your knowledge, if something
like that had occurred or perhaps even only had been planned;
is that correct?</p>
<p class="pindent">BOHLE: Yes, indeed.</p>
<p class="pindent">DR. SAUTER: And then, Witness, I have a last question:</p>
<p class="pindent">Here in the courtroom a further assertion was also made about
the HJ, that is, about the Hitler Youth. It has been asserted that
<span id="Page_17" title="17"></span>
at Lvov it once happened that the Hitler Youth or members of
the Hitler Youth had used little children as targets. Also in this
report no details of course were given, but only the assertion
was made. The following would interest me:</p>
<p class="pindent">As you know the Hitler Youth had, I believe, a membership
toward the end of about 7 to 8 million.</p>
<p class="pindent">THE PRESIDENT: Dr. Sauter, does that have anything to do
with the Auslands-Organisation?</p>
<p class="pindent">DR. SAUTER: Yes, it does insofar as my client, the Defendant
Von Schirach, is charged with the fact that the Hitler Youth abroad
committed such atrocities.</p>
<p class="pindent">THE PRESIDENT: It was not suggested that they did this
abroad, was it—that Hitler Youth ever used children as targets
abroad?</p>
<p class="pindent">DR. SAUTER: Yes, indeed, it was said that at Lvov, in the
Government General, not in Germany, but in Lvov, which means
abroad.</p>
<p class="pindent">THE PRESIDENT: You mean after the war began?</p>
<p class="pindent">DR. SAUTER: Yes.</p>
<p class="pindent">THE PRESIDENT: I thought this witness was speaking about
the same organization before the war.</p>
<p class="pindent">DR. SAUTER: I do not know whether he was also talking about
the Auslands-Organisation during the war. But in any case,
Mr. President, the witness knows these facts, for he was the head
of the Auslands-Organisation. Therefore this witness seems to me
especially qualified to give us information on these matters.</p>
<p class="pindent">THE PRESIDENT: It seems to me that we are very far from
the point, but you can go on.</p>
<p class="pindent">DR. SAUTER: Yes, Mr. President, for otherwise I would have
to call expressly this witness for my client again.</p>
<p class="pindent">Witness, do you at all recall the last question I put to you,
whether you had any knowledge that the Hitler Youth, or members
of the Hitler Youth abroad, which was under your jurisdiction,
is supposed to have committed atrocities of that nature?</p>
<p class="pindent">BOHLE: I regret to tell you, Mr. Attorney, that the Government
General did not belong to the Auslands-Organisation, that
I was never there and therefore am not in a position to state
anything on that point. Obviously the erroneous opinion seems
to exist that the Government General, from the point of view
of the organization of the Party, was connected with the Auslands-Organisation;
however that was not the case. I had no organizational
powers there.
<span id="Page_18" title="18"></span></p>
<p class="pindent">DR. SAUTER: Otherwise, I have no further questions.</p>
<p class="pindent">DR. ROBERT SERVATIUS (Counsel for the Leadership Corps
of the Nazi Party): Witness, to what extent, in your capacity as
Reichsleiter of the Auslands-Organisation, were you informed
about the foreign political intentions of the Führer?</p>
<p class="pindent">BOHLE: I was not Reichsleiter, but Gauleiter, and was never
informed of the foreign political intentions of the Führer.</p>
<p class="pindent">DR. SERVATIUS: Do you know whether the Führer basically
advocated to your organization an understanding with England?</p>
<p class="pindent">BOHLE: I do not quite understand your question.</p>
<p class="pindent">DR. SERVATIUS: Did Hitler, before the war, in your presence
and before the other Gauleiter, frequently emphasize the fact that
he wanted at all costs an understanding with England, and that
you also were to work for its achievement?</p>
<p class="pindent">BOHLE: I received no orders in this respect from the Führer,
but certainly from the Deputy of the Führer. The Führer never
discussed foreign political matters with me during the 12 years I
was in office.</p>
<p class="pindent">DR. SERVATIUS: I have no further questions.</p>
<p class="pindent">THE PRESIDENT: Do any members of the Defense Counsel want
to ask any other questions?</p>
<p class="pindent">LIEUTENANT COLONEL J. M. G. GRIFFITH-JONES (Junior
Counsel for the United Kingdom): Your Auslands-Organisation was
organized in the same way as the Party in Germany was organized;
is that not so?</p>
<p class="pindent">BOHLE: Not in all points, because there were various organizations
within the body of the Party in the Reich which were not
intended for foreign countries, for example, the Office for Municipal
Policy.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Perhaps I can shorten my question:
Did you have Hoheitsträger abroad in the same way as you had
them in Germany?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: The organization in each country
was under the Landesgruppenleiter; is that correct?</p>
<p class="pindent">BOHLE: In almost all countries.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And under many there were lower-ranking
Hoheitsträger?</p>
<p class="pindent">BOHLE: Yes, the Ortsgruppenleiter.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Was the result of that, that you had
your German population in foreign countries well organized and
known to the leaders in those countries?
<span id="Page_19" title="19"></span></p>
<p class="pindent">BOHLE: To a great extent that might be correct, but it was not
so thoroughly organized, nor could it actually be so, because the
leader of the Party did not know all the Reich Germans in the
country concerned.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Did it never occur to you that in
the event of your army’s invading a country where you had a well-organized
organization, that organization would be of extreme military
value?</p>
<p class="pindent">BOHLE: No, that was not the sense and the purpose of the Auslands-Organisation
and no offices ever approached me in this connection.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Are you telling this Tribunal now
that when the various countries of Europe were in fact invaded by
the German Army your local organizations did nothing to assist
them in a military or semimilitary capacity?</p>
<p class="pindent">BOHLE: Yes, indeed.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. Now, let me ask you
about something else for a moment: You had, had you not, an efficient
system of reporting from your Landesgruppenleiter to your
head office in Berlin?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I think you have said yourself, did
you not, in your interrogations, that you took an especial pride in
the speed with which your reports came back?</p>
<p class="pindent">BOHLE: I did not say that, I believe, with respect to speed but
rather with respect to the accuracy of their political survey.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: In fact, your reports did come back
with great speed, did they not?</p>
<p class="pindent">BOHLE: I cannot say that in general. It depended on the possibility
of dispatching these reports quickly to Berlin, and how far
that was the case in individual instances, I naturally cannot say
today. In any case, I had no special speed or acceleration measures
at my disposal.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: In fact, you told your interrogator—and
I can refer you to it if necessary—that on occasion you got
back information before Himmler or the Foreign Office had got
similar information.</p>
<p class="pindent">BOHLE: That must be a misunderstanding. It concerns the
political reports from the Landesgruppenleiter which I transmitted
from Berlin to the different offices.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well, we will leave the speed
out. I have it from you that you had an efficient system of reporting,
had you not?
<span id="Page_20" title="20"></span></p>
<p class="pindent">BOHLE: In order to answer that question I would have to know
in respect to what reports I am supposed to have had an efficient
system of reporting.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: That was going to be my next question.
I was going to ask you: What in fact did your Landesgruppenleiter
report to you?</p>
<p class="pindent">BOHLE: The Landesgruppenleiter reported of their own accord
to me, whenever they had anything of importance which they wanted
to report to the competent offices in the Reich.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Did they ever report anything
which might have been of military or semimilitary value?</p>
<p class="pindent">BOHLE: That may have been the case in some instances, although
at present I cannot recall any specific cases.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: They were never given any instructions,
were they, to report that kind of information?</p>
<p class="pindent">BOHLE: No, generally not.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: How did you get your reports
back? Did you have wireless sets with your organization in foreign
countries?</p>
<p class="pindent">BOHLE: No, we did not have any such transmission or wireless
stations. Reports either came through courier in special cases or
were brought by individuals to Germany.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: After the war started, did your
organizations continue in neutral countries?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Did they never have wireless sets
reporting back information?</p>
<p class="pindent">BOHLE: I do not know anything about that. I do not believe
they had them, for I would have had to know about it.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Now, I want to ask you about only
one or two documents. Would you look at 3258-PS—My Lord, that
is the exhibit already in, GB-262; I have copies of the extract for
the Tribunal and members of Defense Counsel. I expect you read
English—the book itself is coming.</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: There you have before you a copy
of some extracts from it. Would you look at the bottom of the
first page, last paragraph, commencing “In 1938...” Did you have
a Landesgruppenleiter in the Netherlands by the name of Butting?</p>
<p class="pindent">BOHLE: Yes.
<span id="Page_21" title="21"></span></p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Just pay attention to me for perhaps
one moment before you look at that document. Do you know
that Butting shared a house at The Hague with the military
intelligence office? Do you know that?</p>
<p class="pindent">BOHLE: No, I do not.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Now, I want to quote you quite
shortly two paragraphs of this document, which is a report, published
as an official United States publication, called “National
Socialism, Basic Principles, Their Application by the Nazi Party’s
Foreign Organization, and The Use of Germans Abroad for Nazi
Aims.” I just want you to tell the Tribunal what you think first
of all about this report, which is printed in that book:</p>
<div class="blockquote">
<p class="calibre3">“In 1938 the German Legation owned two houses in The
Hague. Both were of course the subject of diplomatic
immunity and therefore inviolable as concerned search and
seizure by the Dutch police. I shall call the house in which
Dr. Butting had his office House Number 2. What went on
in House Number 2? It had been remodeled and was divided
like a two-family house—vertically, not horizontally, but
between the two halves there was a communicating door.
One side of the house was Dr. Butting’s. The other half
housed the Nazi military intelligence agent for Holland....”</p>
</div>
<p class="pindent">You say that you do not know anything about that?</p>
<p class="pindent">BOHLE: Butting was Landesgruppenleiter of the Auslands-Organisation.
I am hearing about this house—or these two houses—for
the first time, that is quite new to me.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. I will just go on.</p>
<div class="blockquote">
<p class="calibre3">“S. B. (the military intelligence agent) may have had as many
as a dozen subordinates working in Holland, all subagents
of the Canaris bureau. These were professional spies who
knew their trade. But they could not possibly know Holland
as intimately as was required by the strategy of the German
High Command, as it was revealed following the invasion
of May 1940. For this, not a dozen but perhaps several
hundred sources of information were necessary. And it is at
this point that Butting and the military intelligence agent
come together. Through his German Citizens’ Association,
Butting had a pair of Nazi eyes, a pair of Nazi ears, in
every town and hamlet of the Netherlands. They were the
eyes and ears of his minor Party officials. Whenever the
military intelligence agent needed information concerning
a corner of Holland which his people had not yet explored,
or was anxious to check information relayed to him by one
of his own people, he would go to Butting.”</p>
</div>
<p class="pindent"><span id="Page_22" title="22"></span></p>
<p class="pindent">Do you know whether Butting assisted the military intelligence
agent in Holland in any way like that?</p>
<p class="pindent">BOHLE: I was told later that he aided in Holland. To what
extent he helped him I do not know, for he had had no such mission
from me.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I understand, he had no instructions
but he was doing it. Just turn now to the last paragraph
on that page, too:</p>
<div class="blockquote">
<p class="calibre3">“ ‘I know every stone in Holland,’ S. B. once boasted. By
‘stone’ he meant canal, lock, bridge, viaduct, culvert, highway,
by-road, airport, emergency landing field, and the name
and location of Dutch Nazi sympathizers who would help the
invading army when the time came. Had Dr. Butting’s Party
organization not existed under the innocent cover of his
Citizens’ Association, S.B.’s knowledge of Holland would have
been as nothing compared with what it was. Thus the
Citizens’ Association served a double purpose; it was invaluable
for espionage at the same time as it fulfilled its primary
function as a Fifth Column agency.”</p>
</div>
<p class="pindent">Do you know whether the members of your organization in
Holland were given instructions to learn about every canal, lock,
bridge, viaduct, railway, and so on?</p>
<p class="pindent">BOHLE: No, I had not the least idea of this.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well. I want you to be quite
clear. I am putting to you that your organization was in the first
place an espionage system reporting information of importance
back to the Reich, and, in the second place, it was an organization
aimed to help, and which did help, your invading German armies
when they overran the frontiers of their neighboring states. Do
you understand those two points?</p>
<p class="pindent">BOHLE: Yes, indeed.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Did your organization publish an
annual book, your <span class="it1">Year Book of the Foreign Organization</span>?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And did that book contain information
as to the activities of your organization during the year?</p>
<p class="pindent">BOHLE: Partially, yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I suppose that the Tribunal would
be safe in assuming that what was published in that book was
accurate information?</p>
<p class="pindent">BOHLE: One may assume that.
<span id="Page_23" title="23"></span></p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at the <span class="it1">Year Book
for 1942</span>? I have copies of the extracts. Would you turn to
Page 37 of that book? If you look back one or two pages in
the book, you will find that that is an article entitled “The Work
of the Norway Branch of the Auslands-Organisation in the War.”
Is that written by your Landesgruppenleiter in Norway?</p>
<p class="pindent">BOHLE: I assume so, I cannot recall this.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at Page 37, and
you will see that there are some passages in the book that you
have in front of you that have been lightly marked in pencil along
the side.</p>
<p class="pindent">BOHLE: Yes, I have it.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you find the paragraph which
starts, “Therefore, soon after the outbreak of war in September
1939...” Have you got that?</p>
<p class="pindent">BOHLE: Yes, I have it.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Perhaps you will be so kind as to
follow me.</p>
<div class="blockquote">
<p class="calibre3">“Therefore, soon after the outbreak of war in September 1939,
the enlargement and extension...”</p>
</div>
<p class="pindent">BOHLE: Yes, I am following you.</p>
<div class="blockquote">
<p class="calibre3">LT. COL. GRIFFITH-JONES: “...the enlargement and extension
of the German Legation in Oslo and of the consulates
at Bergen, Trondheim, Stavanger, Kristiansand, Hamgesund,
Narvik and Kirkenes proved to be of primary importance.
This enlargement of the Reich agencies resulted in the local
organization of the NSDAP in Norway having to increase
its field of activity too, in the same proportion, in order
to support the work of the Reich agencies, particularly by
Party members and other Germans who had a thorough
knowledge of the country and language.”</p>
</div>
<p class="pindent">Why, in September ’39, was it necessary for the Party to
increase its organization in Norway with people having higher
knowledge of the country and language? Answer me that before
you read on. You need not worry about the rest; we are going
to deal with it. Why was it necessary in 1939 to enlarge your
organization?</p>
<p class="pindent">BOHLE: In Norway, as far as I recall, there were only 80
members of the Party in all, and it goes without saying that
after the outbreak of the war the official agencies, not only of
Germany but also, as you know, those of other states, were enlarged
and were assisted by national elements, who knew the country
<span id="Page_24" title="24"></span>
concerned. That did not hold true for Germany alone but for
all the nations participating in the war.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Yes. I still do not understand
why your perfectly harmless organization should have found it
necessary to increase its membership with people who had a
profound knowledge of the language and the country. Why should
the Auslands-Organisation have found it necessary?</p>
<p class="pindent">BOHLE: Because the Reich agencies needed Germans who knew
the country and the people, especially to furnish information on
the German targets of attack in Norway—exactly what every
other nation did, too.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Well, your answer is, is it, that
you required them to tell you about targets in Norway? Is that
your answer?</p>
<p class="pindent">BOHLE: No, I did not say that. I said that they were to be
at the disposal of the agencies in Norway in case they were needed
for public enlightenment, that is for German propaganda purposes
among the Norwegians. I would like to emphasize once again
that that was done not only by Germany but, of course, by all
the warring countries.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well, let us go on and see
what happens next:</p>
<div class="blockquote">
<p class="calibre3">“The choice and assignment of these supplementary collaborators
was carried out by the local leader of the organization
in close collaboration with the representatives of the Reich.
Therefore, from the first moment of the outbreak of war
a great number of Party members were taken away from
their jobs and employed in the service of the nation and
the fatherland. Without any hesitation and without considering
their personal interests, their families, their careers
or their property, they joined the ranks and devoted themselves
body and soul to the new and often dangerous tasks.”</p>
</div>
<p class="pindent">Tell me, was finding out and reporting about the Norwegian
people, was that an “often dangerous task”?</p>
<p class="pindent">BOHLE: Certainly not.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: What, then, were the often
dangerous tasks which your own Landesgruppenleiter is saying
members of his organization were undertaking from the very
moment war broke out, in September ’39?</p>
<p class="pindent">BOHLE: I cannot tell you anything about that, for I have no
knowledge whatsoever about this and I cannot conceive any of
these dangerous tasks. I have the impression from this article,
which, incidentally I did not know about until now, that the
<span id="Page_25" title="25"></span>
Landesgruppenleiter had the plausible desire to give more importance
to his organization than it had in reality.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: But you say you did not know
about this. This appeared in the official yearbook of your organization.
Did you never read what appeared in that book?</p>
<p class="pindent">BOHLE: Certainly not everything, for I am not familiar with
this article.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You have told us that the members
of your organization took no part in this. What about the
people who were responsible for publishing that book? Did they
not ever draw your attention to an article of that kind?</p>
<p class="pindent">BOHLE: Obviously not.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Just look at the next little
paragraph:</p>
<div class="blockquote">
<p class="calibre3">“The success of their work, which was done with all secrecy,
was revealed when, on 9 April 1940, German troops landed
in Norway and forestalled the planned flank attack of the
Allies.”</p>
</div>
<p class="pindent">What work was revealed on the 9th of April? What work
which had been done with all secrecy was revealed on the 9th of
April, work carried out by members of your organization?</p>
<p class="pindent">BOHLE: I am sorry I cannot reply, for I have no knowledge
whatsoever of this. I do not know.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I see. Will you look down to the
last paragraph of that page? It is the second sentence—four, five
lines down—at the end of the fifth line. I beg your pardon. You
have the book in front of you. Will you look at Page 40 of the
book? In the center of a paragraph the last word of one of the
lines starts with “According to the task plan...” Have you got
it? It is Page 40. To save time, let me read it:</p>
<div class="blockquote">
<p class="calibre3">“According to the task plan which had been prepared
since the outbreak of the war, the Landeskreisleitung gave
orders on 7 April for Phase 1 of the state of employment...”</p>
</div>
<p class="pindent">It does not sound, does it, like plans being made for different
phases of an operation? It does not sound, does it, as if the work
of your organization had been simply finding out about Norwegian
people?</p>
<p class="pindent">BOHLE: That might have been since this is entirely new to
me, exclusively an agreement within the country itself with military
or other authorities. I have had no knowledge of it up to this
moment.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: So I understand you to say. But
you were the head of this organization, were you not?
<span id="Page_26" title="26"></span></p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You have come before this International
Tribunal and given them evidence, presumably saying you
are in a position to give them truthful and accurate evidence; is
that so?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you understand that?</p>
<p class="pindent">BOHLE: Yes, I have understood that.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Well, then, do I understand you to
say now that you do not know what was happening in your organization,
and therefore you are not in a position to give evidence as to
whether or not it was a Fifth Column business?</p>
<p class="pindent">BOHLE: It is quite evident that in an organization of this size
the leader, who has his office at Berlin, cannot be closely acquainted
with everything which is going on abroad and, more so, what is done
against his instructions. I did not have the same disciplinary authority
over my Party members abroad as did, for instance, some Gauleiter
within the Reich. I need not elaborate on that, because it is
self-evident. It is also evident, and this I know, that some Germans
abroad, who were called on because of their patriotism in individual
cases let themselves be used for purposes without the knowledge of
the Auslands-Organisation and against its explicit instructions.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: In the interest of time we will not
pursue that particular sphere of activity in Norway, just in case it
may have been an exception which you did not know about.</p>
<p class="pindent">Let me turn to something else. Will you look at Page 65 of
that book?</p>
<p class="pindent">Is that an article by your Landesgruppenleiter in Greece?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Is it in the form of a day-to-day
diary of the activities of the Auslands-Organisation in Greece when
German troops invaded that country?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you look at Page 65?</p>
<div class="blockquote">
<p class="calibre3">“Sunday the 27th of April. Swastika on the Acropolis.”</p>
</div>
<p class="pindent">That is the heading. I beg your pardon. I do not know whether
it comes directly under that heading. This is the Landesgruppenleiter
talking:</p>
<div class="blockquote">
<p class="calibre3">“I set out immediately, quickly visiting the other quarters,”—where
the German colony had been interned—“the Philadelphia
and the Institute. I enjoined the inmates of the house
<span id="Page_27" title="27"></span>
in Academy Street to give up returning home today, and to
hold themselves in readiness. After all, we did want to help
the German troops immediately with our knowledge of the
language and the district. Now the moment has come. We
must start in immediately.”</p>
</div>
<p class="pindent">Do you know...</p>
<p class="pindent">BOHLE: Yes, I even know all about this. It certainly must be
evident that the moment German troops occupied a foreign city and
freed the Germans living abroad who had been interned, the latter
would put themselves at the disposal of the German troops and help
them in every respect as guides, interpreters, or the like. That is
certainly the most logical thing in the world.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: That is in fact what they did do,
and the assistance that your organization appears to have given
them is that it managed to organize them and get them ready to
do it; is that not so? That is what your Landesgruppenleiter seems
to be doing?</p>
<p class="pindent">BOHLE: I did not understand this question. Will you please
repeat it?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you understand that it is your
Landesgruppenleiter who is organizing the members of your organization,
organizing them so that they can give their assistance most
beneficially to the invading armies?</p>
<p class="pindent">BOHLE: That is a completely wrong way to express it. The
Landesgruppenleiter in Greece, who filled that post from 1934, could
not possibly tell whether there was to be an invasion of Greece or
not. That had not the slightest thing to do with the nature of his
organization. The moment that German troops were in the country
it stands to reason that they would welcome their countrymen, act
as their hosts, and help them in every way. That was a patriotic
duty taken for granted.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I see.</p>
<p class="pindent">Just turn to Page 66, the next page. Will you find the paragraph
which commences “Meanwhile I organized the employment of all
Party members to do auxiliary service for the Armed Forces.”</p>
<p class="pindent">Do you have that?</p>
<p class="pindent">BOHLE: I understand it...</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You had better find the place.</p>
<p class="pindent">BOHLE: Where shall I find that place?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: On Page 66. It is a new paragraph.</p>
<p class="pindent">BOHLE: Yes, I have it now.
<span id="Page_28" title="28"></span></p>
<p class="pindent">LT. COL. GRIFFITH-JONES: “Meanwhile I organized the employment
of all Party members to do auxiliary service for the Armed
Forces.”</p>
<p class="pindent">It really looks now as though the Landesgruppenleiter is organizing
them, does it not?</p>
<p class="pindent">BOHLE: In this instance, yes.</p>
<div class="blockquote">
<p class="calibre3">LT. COL. GRIFFITH-JONES: “Soon our boys and girls could
be seen riding proud and radiant in their Hitler Youth uniforms,
beside the German soldiers on motorcycles and in
Army cars....”</p>
</div>
<p class="pindent">Did you yourself know of the organization and work that your
Landesgruppenleiter had put in in Greece to assist your armies in
semimilitary capacities, or was that another case like Norway which
you did not know anything about?</p>
<p class="pindent">BOHLE: The Landesgruppenleiter in Greece did not create a
semimilitary organization, but set up of course in this instance an
organization to aid the troops entering the country in a sector which
was entirely civilian.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Very well; I just want to ask you
about another matter. Have you got a document there which is a
telegram from somebody called Stohrer, in Madrid?</p>
<p class="pindent">BOHLE: Stohrer, yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Did Stohrer have something to do
with the German Embassy in Madrid?</p>
<p class="pindent">BOHLE: Stohrer was the German Ambassador himself; Doctor
Von Stohrer.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: This is dated 23 October 1939. Just
let us see what it says:</p>
<div class="blockquote">
<p class="calibre3">“The Landesgruppenleiter can obtain a very suitable house
for accommodating the Landesgruppe, as well as the German
Labor Front, the Ortsgruppe, the Hitler Youth, and the German
House Madrid, also room available in case of embassy
having to spread out, and especially a very suitable isolated
room for the possible installation of second secret radio transmitter,
which can no longer be housed at the school because
of reopening.</p>
<p class="calibre3">“Landesgruppenleiter requests me to rent the house through
the embassy, in which way very considerable tax expense
will be avoided. Have no hesitation, in view of anticipated
partial use by embassy as mentioned above. If you do not
agree I request wire by return.</p>
<p class="calibre3">“Please submit also to Gauleiter Bohle.”</p>
</div>
<p class="pindent"><span id="Page_29" title="29"></span></p>
<p class="pindent">Were you telling the truth to this Tribunal when you told them
some 30 minutes ago that you had no knowledge of wireless sets
being used by your organization?</p>
<p class="pindent">BOHLE: Yes, because I have no knowledge of these transmitters,
or their use; I must assume that it concerns apparatus of the
embassy.</p>
<p class="pindent">DR. SEIDL: The copy of the telegram, as I have it before me,
does not indicate to whom this wire was addressed. The last sentence
of the telegram leads one to assume that it was not in any
case addressed to the witness. According to my opinion, I think the
witness should next be asked whether he knew about this wire and
to whom it was addressed.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Perhaps you will tell Dr. Seidl to
whom the Ambassador in Madrid was likely to send a telegram on
such matters as this?</p>
<p class="pindent">BOHLE: To the Foreign Office at Berlin.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And you, at that time, were State
Secretary at the Foreign Office of Berlin, were you not?</p>
<p class="pindent">BOHLE: Quite right, in October 1939.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Beneath his signature is set out the
distribution to—it mentions various persons in departments in the
Foreign Office in Berlin. Is that so?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And are you saying now that all
of those departments which were asked to submit this matter to
you, that they all failed to do so?</p>
<p class="pindent">BOHLE: No, I do not claim that. They surely would have
done that.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Do you remember yourself seeing
this telegram before?</p>
<p class="pindent">BOHLE: I cannot recall it. I would have noticed it for I never
heard anything about two secret transmitters in Spain. It would
also be quite in order for me to admit it. But I cannot do so if I
do not know it. The distribution under Number 3 mentions "State
Secretary,” but that does not mean me, but the State Secretary of
the Foreign Office, the political one. My designation in the Foreign
Office was: Chief A.O.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I can save you all that. I am not
suggesting that that “State Secretary” means you; otherwise it would
not be asked to be submitted to you. What I want to know is what
you or your embassy workers, or both of you working together,
<span id="Page_30" title="30"></span>
wanted with two secret wireless transmitting sets in Spain in October
1939?</p>
<p class="pindent">Are you still saying that your organization was quite unconcerned
in reporting back information of military importance?</p>
<p class="pindent">BOHLE: Just how do you mean, “reporting back”?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Are you telling the Tribunal—I
want you to be quite clear—are you telling the Tribunal that your
organization was not being used for espionage purposes in Spain?</p>
<p class="pindent">BOHLE: Yes indeed, I am asserting that. A distinction must be
made between certain members of the Auslands-Organisation who
naturally without my knowledge—I protested against this often
enough—were used abroad for such purposes. I had no objection to
Germans abroad being utilized in time of war for such tasks, as was
the case very frequently with all other countries. However, I did
not want members or officials of the Auslands-Organisation to
become involved. A distinction must...</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I do not want to stop you at all.
I do not want to stop you. Go on if you have anything to say. But,
in the interest of time, try and make it as short as possible.</p>
<p class="pindent">BOHLE: It seems to me there is some confusion between the Auslands-Organisation
as an organization and what certain Germans
abroad did during the war as their patriotic duty. This seems to me
to be the crucial point of the question.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Well, I will not argue about that.
We see that your organization took sufficient interest to reproduce
accounts of what they were doing in its official book. I just want
to show you one thing further.</p>
<p class="pindent">[<span class="it1">Turning to the President.</span>] Well, I have one further document
to put to this witness.</p>
<p class="pindent">THE PRESIDENT: You may as well go on.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: It is a document which I have just
had found. I have not had them copied. The Tribunal will forgive
me if I read extracts from them?</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] It is an original document you hold
in your hand and it appears to be, does it not, a carbon copy of a
letter from...</p>
<p class="pindent">THE PRESIDENT: Has Dr. Seidl got one?</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Yes, he has one in German.</p>
<p class="pindent">[<span class="it1">Turning to the witness.</span>] Is that a letter from your Landesgruppenleiter
Konradi?
<span id="Page_31" title="31"></span></p>
<p class="pindent">BOHLE: It seems to be a directive from Konradi, but not signed
by him.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: If you will look at the end of the
letter you will see that it is actually signed “Konradi,” after the
usual “Heil Hitler”...</p>
<p class="pindent">BOHLE: The copy that I have is not signed.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Will you get that copy back? Perhaps
these documents...</p>
<p class="pindent">[<span class="it1">The document was taken from the witness to Lt. Col. Griffith-Jones.</span>]</p>
<p class="pindent">It is in fact signed “Konradi.” Show it to him.</p>
<p class="pindent">[<span class="it1">The document was returned to the witness.</span>]</p>
<p class="pindent">BOHLE: It is not signed by Konradi, but typed in.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I am very much obliged to you. It
is my fault for not making myself clear. I told you that we have
here a carbon copy. A copy of a letter which was signed and sent
by Konradi. That appears to be so, does it not?</p>
<p class="pindent">BOHLE: That I do not know, for of course I do not know about
all the letters written by Konradi.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: You can take it, so far as you are
concerned, that that is a German document which has been captured,
that it is this bit of paper that you are holding in your hand which
was found by Allied troops and that bears a typewritten signature
of Konradi, who was your Landesgruppenleiter in Romania; is that
correct? You remember that you had a Landesgruppenleiter in
Romania?</p>
<p class="pindent">BOHLE: His name was Konradi.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: And is this a letter of instructions
to the Zellenleiter in Constantsa?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: It is dated the 25th of October 1939.
Will you read the first paragraph?</p>
<div class="blockquote">
<p class="calibre3">“From 9 to 12 October conferences took place with the
Supreme Party functionaries, or their deputies, of the Southeastern
and Southern European groups at the head office of
the Auslands-Organisation.”</p>
</div>
<p class="pindent">Does that mean Berlin?</p>
<p class="pindent">BOHLE: Yes. Berlin.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: That means your office, does it not?</p>
<p class="pindent">BOHLE: Yes, in my office, but not in my personal office.
<span id="Page_32" title="32"></span></p>
<p class="pindent">LT. COL. GRIFFITH-JONES: No, but is it in the office over which
you had complete control?</p>
<p class="pindent">BOHLE: Yes.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: Agreed. I imagine, before we go
on, that no orders would be issued from your head office at a
conference of that kind which were contrary to your direction,
would they?</p>
<p class="pindent">BOHLE: Not on important things, naturally not.</p>
<p class="pindent">LT. COL. GRIFFITH-JONES: I am much obliged to you.</p>
<div class="blockquote">
<p class="calibre3">“I subsequently received direct instructions from the competent
department of the head office of the Auslands-Organisation.”</p>
</div>
<p class="pindent">So it appears that the direction given at the conference was confirmed
in writing.</p>
<div class="blockquote">
<p class="calibre3">“During the war, every National Socialist abroad must directly
serve the fatherland, either through propaganda for the German
cause or by counteracting enemy measures.”</p>
</div>
<p class="pindent">Now perhaps you will turn over, or rather, you will miss out—I
am reading from copy—the English, the next paragraph, and
the next plus one paragraph, and go on to the paragraph commencing:</p>
<div class="blockquote">
<p class="calibre3">“As everywhere else it is extremely important to know where
the enemy is and what he is doing...”</p>
</div>
<p class="pindent">I want you to be quite clear about this and keep it in mind.
These are directions coming directly from your head office in Berlin.</p>
<div class="blockquote">
<p class="calibre3">“It has been ascertained that the I.S. (Intelligence Service)
has attempted, sometimes most successfully, to gain admittance
for seemingly trustworthy persons into the activities
of the Party group and its associate organizations. It is therefore
necessary that you thoroughly investigate not only all
those persons coming into contact with you who are not very
well known to you, and above all you must scrutinize any
new persons and visitors appearing in your immediate vicinity.
If possible, let them be taken in hand by a comrade whose
absolute Nazi convictions are not generally known to the man
in the street....”</p>
</div>
<p class="pindent">I think we can leave the rest of that.</p>
<div class="blockquote">
<p class="calibre3">“You are to report everything that comes to your notice, even
though it may at first appear very insignificant. Rumors
suddenly arising also come in this category, however false
they may be.”</p>
</div>
<p class="pindent">Do you remember your members in Romania being told to report
everything? Everything they saw?
<span id="Page_33" title="33"></span></p>
<p class="pindent">BOHLE: Yes, of course.</p>
<div class="blockquote">
<p class="calibre3">LT. COL. GRIFFITH-JONES: “An important section of both
your work and that of your comrades’ work must be industrial
concerns, business enterprises, <span class="it1">et cetera</span>. Not only can
you spread your propaganda very well in this way, but it is
precisely in such concerns that you can easily pick up information
concerning strange visitors. It is known that the
enemy espionage organizations are especially active in industrial
circles both in gathering information and carrying out
acts of sabotage. Members with close connections with shipping
and forwarding companies are particularly suitable for
this work. It goes without saying that you must be meticulous
and cautious when selecting your assistants.”</p>
</div>
<p class="pindent">THE PRESIDENT: Do you have some more to read from this
document? If so, we will adjourn now until 2 o’clock.</p>
<h3 class="calibre17 sigil_not_in_toc" id="pgepubid00003">[<span class="it1">The Tribunal recessed until 1400 hours.</span>]</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?220db960